import React, { useState, useEffect } from "react";
import { CategoryTextComponent } from "./CategoryTextComponent";

interface CategoryTextProps {
  groupId: string;
}

export const CategoryText: React.FC<CategoryTextProps> = ({ groupId }) => {
  const [categoryText, setCategoryText] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  // const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Load category text data
  const loadCategoryText = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/group_page/${groupId}/text`);
      if (!response.ok) {
        throw new Error(`Failed to fetch category text: ${response.status}`);
      }
      const data = await response.json();
      console.log("Category text data:", data);
      setCategoryText(data);
    } catch (error) {
      console.error("Error loading category text:", error);
    } finally {
      setLoading(false);
    }
  };

  // Load category text on mount
  useEffect(() => {
    loadCategoryText();
  }, [groupId]);

  if (loading) {
    return null; // Don't render anything while loading
  }

  return (
    <>
      {/* Top category text */}
      {categoryText && categoryText.top && categoryText.top.length > 0 && (
        <div className="page-category__description">
          <CategoryTextComponent text={categoryText.top.join("")} />
        </div>
      )}

      {/* Bottom category text - moved under products */}
      {categoryText &&
        categoryText.bottom &&
        categoryText.bottom.length > 0 && (
          <>
            <div className="page-category__description">
              <CategoryTextComponent text={categoryText.bottom.join("")} />
            </div>
            {/* <button
              type="button"
              className={`page-category-description-toggler ${
                isDescriptionExpanded ? "hidden" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDescriptionExpanded(true);
              }}
            >
              Prikaži više
            </button> */}
          </>
        )}
    </>
  );
};
